import { ApiSdk } from '@/httpclient';
import { Select, SelectProps } from 'antd';
import React from 'react';

export default function NationalityInput(props: SelectProps<any>) {
  const [countries, setCountries] = React.useState<Array<any>>([]);

  React.useEffect(() => {
    getCountries();
  }, []);

  const getCountries = () => {
    ApiSdk.CountryService.getCountries({ pageSize: 250, orderBy: 'name', orderByAsc: true }).then(res => {
      setCountries(
        res.data?.map(d => ({
          value: d.shortCode,
          label: d.name,
        })) || [],
      );
    });
  };

  return (
    <Select
      maxTagCount="responsive"
      allowClear
      {...props}
      filterOption={(input, option) => {
        return (option?.label as string)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
      options={countries}
    ></Select>
  );
}
